import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import { posSystemTypes } from 'appConstants';
import {
	DeviceFullInfoContext,
	IDeviceFullInfoContext,
} from '../../../../../deviceFullInfoState/deviceFullInfoContext';

const PosField: React.FC = () => {
	const { deviceForFullInfo } = useContext<IDeviceFullInfoContext>(DeviceFullInfoContext);

	const posSystemName = posSystemTypes.find((el) => el.posSystemID === deviceForFullInfo?.posSystemId)?.posSystemName;

	return <FullInfoField label="posLabel" value={posSystemName} />;
};

export default PosField;
